import { styled } from '@mui/system';
import { colorPalette } from '../../colorPalette';
export const HyperlinkMarkup = styled('a')(({ color, fontSize, extraStyles }) => {
    const defaultStyle = {
        color: color ? colorPalette[color] : colorPalette.gray800,
        fontSize: fontSize || '1.6rem',
    };
    if (extraStyles) {
        return Object.assign(Object.assign({}, defaultStyle), extraStyles);
    }
    return defaultStyle;
});
export const styleForTest = {
    opacity: 0.3,
    margin: '2.5rem',
    fontWeight: 'bold',
};
